import React from 'react';
import Image from 'next/image';
import checkNext from '../../svgs/check_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function CheckNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={checkNext}
      alt={alt ?? 'Check'}
    />
  );
}
